import React, { Fragment, useEffect, useState, useRef } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { useSearchParams } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { Assignment, Code, PictureAsPdf, Save, Visibility } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import { wsCreate } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Box, LinearProgress } from '@material-ui/core';
import columns from './headerTableList';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { currency } from 'hooks/Pipe';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: '500'
  },
  check: { color: 'black', '& span': { fontWeight: 'bold' } },
  input: { display: 'none' },
  linear: { width: '162px' },
  names: {
    fontWeight: 'bold',
    '& span': {
      fontWeight: 100,
      color: 'black'
    }
  }
};

const useStyles = makeStyles(styles);

export default WithApp(function Shopping(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const inputXml = useRef(null);
  const inputPdf = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const [shopping, setShopping] = useState([]);
  const [loading, setLoading] = useState(false);

  const [namePdf, setNamePdf] = useState('');
  const [nameXml, setNameXml] = useState('');
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  async function listBuys(filter) {
    setDataLoading(true);
    let response = await wsFindBy('purch/purchase', { ...filter, origin: 'I' });
    setDataLoading(false);
    if (response.success) setShopping(response.data);
  }

  async function saveFiles() {
    if (inputXml.current.files.length == 0 && inputPdf.current.files.length == 0) {
      showNotify('Seleccione Factura(PDF) y XML ', 'info');
      return;
    } else if (inputXml.current.files.length == 0) {
      showNotify('Seleccione XML ', 'info');
      return;
    } else if (inputPdf.current.files.length == 0) {
      showNotify('Seleccione Factura(PDF) ', 'info');
      return;
    } else if (namePdf !== nameXml) {
      showNotify('Los archivos no coinciden', 'info');
      return;
    }

    setLoading(true);

    let fd = new FormData();
    setDataLoading(true);
    fd.append('xml', inputXml.current.files[0]);
    fd.append('pdf', inputPdf.current.files[0]);
    let response = await wsCreate('purch/purchase', fd);
    setDataLoading(false);
    if (response.success) {
      setLoading(false);
      inputXml.current.value = '';
      inputPdf.current.value = '';
      setNamePdf('');
      setNameXml('');
      listBuys(valueSearch);
      showNotify(response.message);
    } else {
      setLoading(false);
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (searchParams.get('eliminado') !== null) {
      showNotify(searchParams.get('eliminado'));
      setSearchParams({});
    }
  }, [loading]);

  useEffect(() => {
    if (valueSearch.start_date) listBuys(valueSearch);
  }, [valueSearch]);

  return (
    <Fragment>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de Compras</h4>
        </CardHeader>
        <CardBody>
          <GridContainer style={{ backgroundColor: '#eeeeee' }}>
            <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_STORE}>
              <GridItem xs={12} md={4} lg={2} xl={1}>
                <Button
                  color={props.themeContext.buttonColorDanger}
                  onClick={(e) => {
                    e.currentTarget.querySelector('input').click();
                  }}
                  size="sm"
                >
                  <PictureAsPdf /> PDF
                  <input
                    ref={inputPdf}
                    type="file"
                    accept="application/pdf"
                    className={classes.input}
                    onChange={(e) => {
                      if (e.currentTarget.files[0]) {
                        setNamePdf(e.currentTarget.files[0].name.split('.').slice(0, -1).join('.'));
                      }
                    }}
                  />
                </Button>
              </GridItem>
              <GridItem xs={12} md={4} lg={2} xl={1}>
                <Button
                  color={props.themeContext.buttonColor}
                  onClick={(e) => {
                    e.currentTarget.querySelector('input').click();
                  }}
                  size="sm"
                >
                  <Code /> XML
                  <input
                    ref={inputXml}
                    type="file"
                    accept="application/xml"
                    className={classes.input}
                    onChange={(e) => {
                      if (e.currentTarget.files[0]) {
                        setNameXml(e.currentTarget.files[0].name.split('.').slice(0, -1).join('.'));
                      }
                    }}
                  />
                </Button>
              </GridItem>
              <GridItem xs={12} md={4} lg={2} xl={2}>
                <Button
                  color={props.themeContext.buttonColorSuccess}
                  onClick={() => {
                    saveFiles();
                  }}
                  size="sm"
                >
                  <Save /> {loading ? 'Guardando...' : 'Guardar'}
                </Button>
                <div className={classes.linear} style={{ display: loading ? 'block' : 'none' }}>
                  <LinearProgress color="secondary" />
                </div>
              </GridItem>
              <GridItem xs={12} md={12} lg={6} xl={7}>
                <div className={classes.names}>
                  <GridContainer>
                    <GridItem xs={12} lg={12}>
                      PDF: <span>{namePdf}</span>
                    </GridItem>
                    <GridItem xs={12} lg={12}>
                      XML: <span> {nameXml}</span>
                    </GridItem>
                  </GridContainer>
                </div>
              </GridItem>
            </AllowedGuard>
          </GridContainer>
          {dataLoading && <LoadingSpinner />}
          <hr />
          <FilterCustom getFilter={setValueSearch} dateRange zone stateMultiple mark />
          <ReactTable
            formatDate="DD-MM-YYYY"
            excelName="Compras"
            defaultWidth={4650}
            columns={columns}
            data={shopping.map((buy, i) => {
              return {
                num: (
                  <Box>
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_SHOW}>
                      <Button justIcon round simple color={props.themeContext.buttonColor}>
                        <Link to={`${buy.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                  </Box>
                ),
                proc_status: (
                  <Badge color={props.themeContext.buttonColorSuccess} className={classes.total}>
                    {buy.proc_status == 'D'
                      ? 'Borrador'
                      : buy.proc_status == 'V'
                      ? 'Validado'
                      : buy.proc_status == 'C'
                      ? 'Confirmado'
                      : buy.proc_status == 'X'
                      ? 'En espera'
                      : buy.proc_status == 'R'
                      ? 'Recibido'
                      : buy.proc_status == 'A'
                      ? 'Anulado'
                      : buy.proc_status == 'Y'
                      ? 'Preparado'
                      : buy.proc_status == 'T'
                      ? 'Contabilizado'
                      : buy.proc_status == 'Z'
                      ? 'Para NC - compra'
                      : 'NC registrada'}
                  </Badge>
                ),
                WhsName: buy.WhsName,
                GroupNum: buy.PymntGroup,
                tax_date: buy.tax_date,
                CardCode: buy.CardCode,
                cardName: buy.CardName,
                LicTradNum: buy.LicTradNum,
                is_guide: buy.is_guide === 'Y' ? 'Si' : 'No',
                ReceiptType: buy.document_type_description,
                ReceiptSerie: buy.ReceiptSerie,
                ReceiptNumber: buy.ReceiptNumber,
                DocTotal: currency(buy.DocTotal),
                op_gravada: currency(buy.op_gravada),
                op_inafecta: currency(buy.op_inafecta),
                op_exonerada: currency(buy.op_exonerada),
                VatSum: currency(buy.VatSum),
                SumIsc: buy.SumIsc,
                SumOtTrib: buy.SumOtTrib,
                SumOtCarg: buy.SumOtCarg,
                total_discount: currency(buy.total_discount),
                VatSumTotal: currency(buy.VatSumTotal),
                Currency: buy.Currency,
                DocDueDate: buy.DocDueDate,
                DiscPrcnt: parseFloat(buy.DiscPrcnt).toFixed(2) + '%',
                DiscSum: currency(buy.DiscSum),
                doc_status: buy.doc_status == 'O' ? 'Abierto' : 'Cerrado',
                sum_free_transfer: currency(buy.sum_free_transfer),
                sum_bonification: currency(buy.sum_bonification),
                sum_igv: currency(buy.sum_igv),
                created_at: buy.created_at,
                updated_at: buy.updated_at,
                DocDate: buy.DocDate,
                last_process_date: buy.last_process_date,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
